module.exports = __webpack_public_path__ + "images/namipa8ded92ef874cd5c6211ae7658359d0af.png";